export default [
    // 承运商燃油附加费
    {
        path: "fuelsurcharge/list",
        name: "fuelsurChargeList",
        component: () => import(/* webpackChunkName: "fuelsurcharge" */"@/views/fuelsurcharge/index")
    },
    {
        path: "fuelsurcharge/update",
        name: "fuelsurChargeUpdate",
        component: () => import(/* webpackChunkName: "fuelsurcharge" */"@/views/fuelsurcharge/update.vue")
    }
]


